export default "__VITE_ASSET__oWftLhNY__"